const TRANSITION_MS = 180
const EASING = 'cubic-bezier(0.32, 0.72, 0, 1)'

function getArrowElement(): HTMLElement | null {
  return document.querySelector('[data-edge-swipe-arrow]')
}

function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export function updateArrowIndicator(dx: number, frameWidth: number): void {
  const arrow = getArrowElement()

  if (!arrow) return

  const progress = Math.min(Math.max(dx, 0) / frameWidth, 1)
  const offset = Math.min(dx * 0.45, 56)

  arrow.style.transition = 'none'
  arrow.style.opacity = String(Math.min(progress * 2.2, 1))
  arrow.style.transform = `translateY(-50%) translateX(${offset}px) scale(${0.82 + progress * 0.18})`
}

export function hideArrowIndicator(isAnimated = true): void {
  const arrow = getArrowElement()

  if (!arrow) return

  if (!isAnimated || prefersReducedMotion()) {
    arrow.style.transition = 'none'
    arrow.style.opacity = '0'
    arrow.style.transform = 'translateY(-50%) translateX(0) scale(0.82)'
    return
  }

  arrow.style.transition = `opacity ${TRANSITION_MS}ms ${EASING}, transform ${TRANSITION_MS}ms ${EASING}`
  arrow.style.opacity = '0'
  arrow.style.transform = 'translateY(-50%) translateX(0) scale(0.82)'
}
